import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { Stack, Tooltip } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import check_in from "../../assets/USA_Images/dashboard_icons/Check-In.svg";
import checkout from "../../assets/USA_Images/dashboard_icons/Check-Out.svg";
import check_out_dark from "../../assets/USA_Images/dashboard_icons/Check_out_dark.svg";
import Confirmed from "../../assets/USA_Images/dashboard_icons/Confirmed.svg";
import ConfirmedDark from "../../assets/USA_Images/dashboard_icons/ConfirmedDark.svg";
import InvitationDark from "../../assets/USA_Images/dashboard_icons/InvitationDark.svg";
import Invitation from "../../assets/USA_Images/dashboard_icons/Invitations.svg";
import Pre_Registration_icon from "../../assets/USA_Images/dashboard_icons/Pre_Registration_icon.svg";
import check_in_dark from "../../assets/USA_Images/dashboard_icons/ckeckIn_dark.svg";
import registartion from "../../assets/USA_Images/dashboard_icons/dashregistration.svg";
import registerDrack from "../../assets/USA_Images/dashboard_icons/registerDrack.svg";
import self_registrationIcon_dark from "../../assets/USA_Images/dashboard_icons/self_registrationIcon_dark.svg";
import selfregistartion from "../../assets/USA_Images/dashboard_icons/selfregistration.svg";
import vis_check_in from "../../assets/images/dashboard-icons/Check-In.svg";
import vis_checkout from "../../assets/images/dashboard-icons/Check-Out.svg";
import vis_Confirmed from "../../assets/images/dashboard-icons/Confirmed.svg";
import vis_Invitation from "../../assets/images/dashboard-icons/Invitations.svg";
import vis_selfregistartion from "../../assets/images/dashboard-icons/Registration.svg";
import vis_registartion from "../../assets/images/dashboard-icons/SystemIcon.svg";
import ProfileContext from "../../components/ProfileContext";
import { ThemeContext } from "../../theme/ThemeContext";
import DashboardTiles from "../DashBoard/DashboardTiles";

function DashboardCards(props) {
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const { visitorEvents, setVisitorsNotCheckedOut } = useContext(
    ProfileContext,
  );

  const invitation = () => {
    props.getRowData("Invitation");
  };
  const checkin = () => {
    props.getRowData("Checkin");
  };
  const checkOut = () => {
    props.getRowData("checkOut");
  };
  const selfRegistration = () => {
    props.getRowData("selfRegistration");
  };
  const registration = () => {
    props.getRowData("registration");
  };

  const confirmed = () => {
    props.getRowData("confirmed");
  };

  const haventCheckedOut = () => {
    props.getRowData("notCheckedOut");
  };
  const preRegistration = () => {
    props.getRowData("preRegistration");
  };

  const cardStyle = {
    height: "120px",
    backgroundColor: darkMode ? "#0B2E4D" : "#FFFFFF",
    boxShadow: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 20px",
  };

  const cardheadingStyle = {
    color: darkMode ? "white" : "rgba(0, 0, 0, 0.5)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  const cardDataCountStyle = {
    color: darkMode ? "white" : "rgba(61, 73, 119, 1)",
    fontSize: "30px",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{
          width: "100%",
          margin: "0px",
        }}
      >
        <DashboardTiles>
          <Card onClick={checkin} className="card mb-4" style={cardStyle}>
            <CardContent
              className="p-0"
              style={{
                width: "100%",
              }}
            >
              <Grid xs={12}>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="h2"
                  style={cardheadingStyle}
                >
                  {t("commonsCheckIn")}
                </Typography>
              </Grid>
              <Stack
                direction="row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box className="font-size-xxl" style={cardDataCountStyle}>
                  {props.data.checkInVisitors}
                </Box>
                <Box
                  style={{
                    width: "63px",
                    height: "53px",
                  }}
                >
                  <img
                    alt="..."
                    className="img-fluid"
                    src={
                      process.env.REACT_APP_ENVIRONMENT === "USA"
                        ? darkMode
                          ? check_in_dark
                          : check_in
                        : vis_check_in
                    }
                  />
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </DashboardTiles>

        <DashboardTiles>
          <Card onClick={checkOut} className="card mb-4" style={cardStyle}>
            <CardContent
              className="p-0"
              style={{
                width: "100%",
              }}
            >
              <Grid xs={12}>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="h2"
                  style={cardheadingStyle}
                >
                  {t("commonsCheckOut")}
                </Typography>
              </Grid>
              <Stack
                direction="row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box className="font-size-xxl" style={cardDataCountStyle}>
                  {props.data.checkOutVisitors}
                </Box>
                <Box
                  style={{
                    width: "63px",
                    height: "53px",
                  }}
                >
                  <img
                    alt="..."
                    className="img-fluid"
                    src={
                      process.env.REACT_APP_ENVIRONMENT === "USA"
                        ? darkMode
                          ? check_out_dark
                          : checkout
                        : vis_checkout
                    }
                  />
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </DashboardTiles>

        {!visitorEvents && (
          <DashboardTiles>
            <Card
              onClick={haventCheckedOut}
              className="card mb-4"
              style={cardStyle}
            >
              <CardContent
                className="p-0"
                style={{
                  width: "100%",
                }}
              >
                <Grid xs={12}>
                  <Tooltip title={t("APPROVALITEMS006")}>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="h2"
                      style={cardheadingStyle}
                    >
                      {t("APPROVALITEMS006")}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Stack
                  direction="row"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box className="font-size-xxl" style={cardDataCountStyle}>
                    {/* {props.data.selfRegistartions} */}
                    {/* {visitorsNotCheckedOut ? visitorsNotCheckedOut : 0} */}
                    {props.data.notCheckedOut}
                  </Box>
                  <Box
                    style={{
                      width: "63px",
                      height: "53px",
                    }}
                  >
                    <img
                      alt="..."
                      className="img-fluid"
                      src={
                        process.env.REACT_APP_ENVIRONMENT === "USA"
                          ? darkMode
                            ? self_registrationIcon_dark
                            : selfregistartion
                          : vis_selfregistartion
                      }
                    />
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          </DashboardTiles>
        )}

        <DashboardTiles>
          <Card
            onClick={preRegistration}
            className="card mb-4"
            style={cardStyle}
          >
            <CardContent
              className="p-0"
              style={{
                width: "100%",
              }}
            >
              <Grid xs={12}>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="h2"
                  style={cardheadingStyle}
                >
                  {t("PRE_REGISTRATIONS")}
                </Typography>
              </Grid>

              <Stack
                direction="row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box className="font-size-xxl" style={cardDataCountStyle}>
                  {props.data.preRegistrationCount}
                </Box>

                <Box
                  style={{
                    width: "63px",
                    height: "53px",
                  }}
                >
                  <img
                    alt="Pre Registration"
                    className="img-fluid"
                    src={Pre_Registration_icon}
                  />
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </DashboardTiles>

        <DashboardTiles>
          <Card
            onClick={selfRegistration}
            className="card mb-4"
            style={cardStyle}
          >
            <CardContent
              className="p-0"
              style={{
                width: "100%",
              }}
            >
              <Grid xs={12}>
                <Tooltip title={t("APPROVALITEMS002")}>
                  <Typography
                    gutterBottom
                    variant="h6"
                    component="h2"
                    style={cardheadingStyle}
                  >
                    {t("APPROVALITEMS002")}
                  </Typography>
                </Tooltip>
              </Grid>
              <Stack
                direction="row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box className="font-size-xxl" style={cardDataCountStyle}>
                  {props.data.selfRegistartions}
                </Box>
                <Box
                  style={{
                    width: "63px",
                    height: "53px",
                  }}
                >
                  <img
                    alt="..."
                    className="img-fluid"
                    src={
                      process.env.REACT_APP_ENVIRONMENT === "USA"
                        ? darkMode
                          ? self_registrationIcon_dark
                          : selfregistartion
                        : vis_selfregistartion
                    }
                  />
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </DashboardTiles>

        <DashboardTiles>
          <Card onClick={registration} className="card mb-4" style={cardStyle}>
            <CardContent
              className="p-0"
              style={{
                width: "100%",
              }}
            >
              <Grid xs={12}>
                <Tooltip title={t("labelDashBoardTotalWalkInRegistration")}>
                  <Typography
                    gutterBottom
                    variant="h6"
                    component="h2"
                    style={cardheadingStyle}
                  >
                    {t("labelDashBoardTotalWalkInRegistration")}
                  </Typography>
                </Tooltip>
              </Grid>
              <Stack
                direction="row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box className="font-size-xxl" style={cardDataCountStyle}>
                  {props.data.walkinRegistartions}
                </Box>
                <Box
                  style={{
                    width: "63px",
                    height: "53px",
                  }}
                >
                  <img
                    alt="..."
                    className="img-fluid"
                    src={
                      process.env.REACT_APP_ENVIRONMENT === "USA"
                        ? darkMode
                          ? registerDrack
                          : registartion
                        : vis_registartion
                    }
                  />
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </DashboardTiles>

        <DashboardTiles>
          <Card onClick={invitation} className="card mb-4" style={cardStyle}>
            <CardContent
              className="p-0"
              style={{
                width: "100%",
              }}
            >
              <Grid xs={12}>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="h2"
                  style={cardheadingStyle}
                >
                  {t("labelDashBoardTotalReschedule")}
                </Typography>
              </Grid>
              <Stack
                direction="row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box className="font-size-xxl" style={cardDataCountStyle}>
                  {props.data.invitations}
                </Box>
                <Box
                  style={{
                    width: "63px",
                    height: "53px",
                  }}
                >
                  <img
                    alt="..."
                    className="img-fluid"
                    src={
                      process.env.REACT_APP_ENVIRONMENT === "USA"
                        ? darkMode
                          ? InvitationDark
                          : Invitation
                        : vis_Invitation
                    }
                  />
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </DashboardTiles>

        <DashboardTiles>
          <Card onClick={confirmed} className="card mb-4" style={cardStyle}>
            <CardContent
              className="p-0"
              style={{
                width: "100%",
              }}
            >
              <Grid xs={12}>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="h2"
                  style={cardheadingStyle}
                >
                  {t("labelDashBoardTotalWaitingForApproval")}
                </Typography>
              </Grid>
              <Stack
                direction="row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box className="font-size-xxl" style={cardDataCountStyle}>
                  {props.data.confirmedVisitors}
                </Box>
                <Box
                  style={{
                    width: "63px",
                    height: "53px",
                  }}
                >
                  <img
                    alt="..."
                    className="img-fluid"
                    src={
                      process.env.REACT_APP_ENVIRONMENT === "USA"
                        ? darkMode
                          ? ConfirmedDark
                          : Confirmed
                        : vis_Confirmed
                    }
                  />
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </DashboardTiles>
      </Grid>
    </>
  );
}
export default DashboardCards;
